import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-modal-not-allowed-access',
  templateUrl: './modal-not-allowed-access.component.html',
  styleUrls: ['./modal-not-allowed-access.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalNotAllowedAccessComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  onEmitClose(): void {
    this.closed.emit(true);
  }
}
